import angular from 'angular';
import timesheetGridComponent from './timesheet-grid.component';

let timesheetGridModule = angular.module('timesheetGrid', [])
  .component('timesheetGrid', timesheetGridComponent);

export default timesheetGridModule;




// WEBPACK FOOTER //
// ./client/common/directives/timesheet-grid/timesheet-grid.js